module.exports = __webpack_public_path__ + "static/img/kalemi.662b24e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/kalemi.png
// module id = 452
// module chunks = 1